import React from "react";

export default function AvodPreviewMeta({ activeProgram }) {
  const getSubtitle = React.useCallback(() => {
    if (activeProgram) {
      switch (activeProgram.meta.type) {
        case "series":
          return `${activeProgram?.seasons.length} Seasons`;
        case "season":
          return `${activeProgram?.episodes.length} Episodes`;
        case "episode":
        case "feature":
        default:
          return "";
      }
    }
    return "";
  }, [activeProgram]);

  function capitaliseFirstLetter(input) {
    if (!input) {
      return "";
    }
    return input.charAt(0).toUpperCase() + input.slice(1);
  }

  return (
    <div className="avod-preview__meta">
      {activeProgram ? (
        <React.Fragment>
          <div className="avod-preview__meta__title">{activeProgram?.title}</div>
          <div className="avod-preview__meta__subtitle">{getSubtitle()}</div>
          <div className="avod-preview__meta__text">{activeProgram?.progdesc}</div>
          <div className="avod-preview__meta__footer">
            {activeProgram && (activeProgram.meta.type === "series" || activeProgram.meta.type === "season")
              ? `${activeProgram?.rating}`
              : `${activeProgram?.macros.rating}  ${capitaliseFirstLetter(activeProgram?.macros.content_genre)}`}
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
}
